module.exports = __webpack_public_path__ + "img/drag-handle.7a94eeb7.svg";